import setAuthToken from 'auth/setAuthToken'
import axios from 'axios'
import React, { useReducer } from 'react'
import {
  CLEAR_ERRORS,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  TIMEOUT,
  PROFILE_TIMEOUT,
  SET_USER_ROLE,
  USER_LOADED,
} from '../types'
import AuthContext from './authContext'
import AuthReducer from './authReducer'
import { PropTypes } from 'prop-types'
import { useOktaAuth } from '@okta/okta-react'

const AuthState = ({ children }) => {
  const initialState = {
    token: null,
    isAuthenticated: false,
    loading: true,
    user: null,
    userRole: 'submitter',
    error: null,
  }

  const [state, dispatch] = useReducer(AuthReducer, initialState)
  const { oktaAuth } = useOktaAuth()

  const apiUrl = window.config.apiUrl

  // Load User
  const loadUser = async () => {
    if (!oktaAuth.isAuthenticated) {
      oktaAuth.sighOut('/')
      console.log('signed out from loadUser')
    }

    console.log('loading user')
    const userToken = JSON.parse(localStorage.getItem('okta-token-storage'))

    if (state.user === null) {
      // Load token into global headers
      if (userToken?.accessToken?.accessToken) {
        setAuthToken(userToken?.accessToken?.accessToken)
      }

      if (userToken?.accessToken?.claims) {
        let res = await axios.get(
          `${apiUrl}/Contacts/getcontactbyuserid/${userToken.accessToken.claims.uid}`
        )

        res = JSON.parse(res.data.result)[0]

        const newUser = {
          firstName: userToken.idToken.claims.firstName,
          lastName: userToken.idToken.claims.lastName,
          id: userToken.accessToken.claims.uid,
          pkContact: res.pkContact,
          fkVendor: res.fkVendor,
        }
        console.log('user is: ' + JSON.stringify(newUser))
        dispatch({
          type: USER_LOADED,
          payload: newUser,
        })
        console.log('user loaded')
      }

      if (userToken?.accessToken?.claims?.role) {
        console.log(
          'role is: ' + userToken.accessToken.claims.role.includes('reviewer')
        )
        const role = userToken.accessToken.claims.role.includes('reviewer')
          ? 'wic'
          : 'submitter' ?? null
        dispatch({
          type: SET_USER_ROLE,
          payload: role,
        })
      }
    }
  }

  // Login User
  const login = async formData => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    try {
      const res = await axios.post(
        `${apiUrl}/users/authenticate`,
        formData,
        config
      )

      console.log('User data is: ' + res.data.message)

      console.log('login user data: ' + JSON.stringify(res.data))
      dispatch({
        type: LOGIN_SUCCESS,
        payload: JSON.parse(res.data.message),
      })

      // loadUser()
      const role = JSON.parse(res.data.message).Username.includes('ca.gov')
        ? 'wic'
        : 'submitter'
      dispatch({
        type: SET_USER_ROLE,
        payload: role,
      })

      const res_vendor = await axios.get(
        `${apiUrl}/contacts/${JSON.parse(res.data.message).Id}`,
        config
      )

      let res_with_fkVendor = JSON.parse(res.data.message)
      res_with_fkVendor.fkVendor = JSON.parse(
        res_vendor.data.result
      )[0].fkVendor

      dispatch({
        type: LOGIN_SUCCESS,
        payload: res_with_fkVendor,
      })
    } catch (err) {
      dispatch({
        type: LOGIN_FAIL,
        payload: err,
      })
    }
  }
  // Logout
  const logout = () => dispatch({ type: LOGOUT })

  const timeout = () => {
    oktaAuth.signOut('/')
    dispatch({ type: TIMEOUT })
  }

  const profileTimeout = () => {
    oktaAuth.signOut('/')
    dispatch({ type: PROFILE_TIMEOUT })
  }

  // Clear Errors
  const clearErrors = () => dispatch({ type: CLEAR_ERRORS })

  return (
    <AuthContext.Provider
      value={{
        token: state.token,
        isAuthenticated: state.isAuthenticated,
        loading: state.loading,
        user: state.user,
        error: state.error,
        userRole: state.userRole,
        loadUser,
        login,
        logout,
        timeout,
        profileTimeout,
        clearErrors,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

AuthState.propTypes = {
  children: PropTypes.node,
}

export default AuthState
